import Vapi from 'vuex-rest-api';

const fetcherAdminCommonString = new Vapi({
  state: {
    fetcherAdminCommonString: {
      id: 0,
    },
    commonStrings: [],
  },
})
  .get({
    action: 'getFetcherAdminCommonString',
    property: 'fetcherAdminCommonString',
    path: ({ tid }) => `/api/fetcher/admin/commonStrings/${tid}`,
  })
  .getStore();

export default fetcherAdminCommonString;
